import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";

export class GetIbssApiVersion implements IGetIbssApiVersion
{
    public async execute(): Promise<IVersion>
    {
        try
        {
            const response = await axios.get<IVersion>(`${apis.allApi}Service/version`);
            return response.data;
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface IGetIbssApiVersion
{
    execute(): Promise<IVersion>;
}

export interface IVersion
{
    Version: string;
}